import { cache } from "react";
const createAnchorLinkCache = cache(() => {
  const anchorLinksMap = /* @__PURE__ */ new Map();
  return {
    addAnchorLink: (anchorLink) => {
      anchorLinksMap.set(anchorLink.id, anchorLink);
    },
    getAnchorLinks: () => Array.from(anchorLinksMap.values())
  };
});
export {
  createAnchorLinkCache
};
